
import LayoutContent from '../../components/layouts/content2';
import React, {useState, useEffect} from 'react';
import ListProducts from './ListProducts';
import {useTranslation} from 'react-i18next';
import { getData } from '../../helpers/indexedDbHelper';
import SpecialsScreen from './specials';
import SeaseonalCoktailScreen from './seasonalCocktail';
import SpecialityCocktail from './specialityCocktail';
import PeruvianClasic from './peruvianClasic';
import BeerScreen from './beer';
import OldiesButGoodies from './OLDIES';
import SpiritsScreen from './spirits';

function Index({dishs2, setShowBar}) { 

    const {i18n} = useTranslation();
    const langEng = i18n.language === 'en' ?? false;

    const [menus, setMenus] = useState([]);
    const [showSpecials, setShowSpecials] = useState(false);
    const [showSpecialitylCocktail, setShowSpecialitylCocktail] = useState(false);
    const [showSesonalCocktail, setShowSesonalCocktail] = useState(false);
    const [showPeruvianClasic, setshowPeruvianClasic] = useState(false);
    const [showBeer, setshowBeer] = useState(false);
    const [showListProduct, setShowListProduct] = useState(false);
    const [dishs, setdishs] = useState(false);
    const [showspirits, setShowSpirits] = useState(false);
    const [dataCabernet, setdataCabernet] = useState(false);
    const [datamerlot, setdatamerlot] = useState(false);
    const [datanebiolo, setdatanebiolo] = useState(false);
    const [datapinotnoir, setdatapinotnoir] = useState(false);
    const [datamalbec, setdatamalbec] = useState(false);
    const [chenin, setchenin] = useState(false);
    const [suavignon, setsuavignon] = useState(false);
    const [moscato, setmoscato] = useState(false);
    const [chardonnay, setchardonnay] = useState(false);
    const [pinotgrigio, setpinotgrigio] = useState(false);

    const [showOldiesButGoodies, setShowOldiesButGoodies] = useState(false);

     useEffect(() => {
        getData('menu').then((items) => {
            const data = items.value.data;
            setMenus(data);
        });
     }, []);
    
    
    useEffect(() => {
        menus.map((item) => {
            if (item.id === 668) {
                setdataCabernet(item);
            }
            if (item.id === 669) {
                setdatamerlot(item);
            }
            if (item.id === 670) {
                setdatanebiolo(item);
            }
            if (item.id === 671) {
                setdatapinotnoir(item);
            }
            if (item.id === 672) {
                setdatamalbec(item);
            }
            if (item.id === 673) {
                setchenin(item);
            }
            if (item.id === 674) {
                setsuavignon(item);
            }
            if (item.id === 675) {
                setmoscato(item);
            }
            if (item.id === 676) {
                setchardonnay(item);
            }
            if (item.id === 677) {
                setpinotgrigio(item);
            }
            });
    }, [menus]);
    
    
    return (
        <div style={{position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', zIndex: 9999}}>
            <LayoutContent showBack={true} setShowSpecials={setShowSpecials} goHome={setShowBar} setShowListProduct={setShowBar}>
                <div style={{ padding: '0 20px' }}>
                     <img
                        src={require('./assets/top.png')}
                        style={{
                        objectFit: 'contain',
                        width: '100%',
                        height: 140,
                        marginTop: -10,
                        }}
                    />
                    <p style={{color: '#D7BF89', textAlign: 'center', fontSize: 35}}>
                        RED WINES
                    </p>

                    <div
                        style={{
                            display: 'flex',
                            marginTop: 20,
                            flexDirection: 'row',
                            alignSelf: 'center',
                            justifyContent: "center"
                        }}>
                        <div
                            onClick={() => {
                                setdishs(dataCabernet)
                            setShowListProduct(true)
                            }}
                            style={{
                            display: 'flex',
                            justifyContent: 'center',
                                alignItems: 'center',
                            position: 'relative'
                        }}>
                            <img
                                onContextMenu={(e) => e.preventDefault()}
                                
                                src={require('./assets/bk.png')}
                                style={{
                                    objectFit: 'contain',
                                    width: 200,
                                    pointerEvents: 'none',
                                    height: 120,
                                }}
                            />
                            <div style={{position: 'absolute'}}>
                               
                                <p
                                    style={{color: 'white', textAlign: 'center', fontSize: 17}}>
                                    CABERNET <br/>
                                    SAUVIGNON
                                </p>
                            </div>
                        </div>

                        <div
                            onClick={() => {
                                setdishs(datamerlot)
                                setShowListProduct(true)
                           }}
                            style={{
                                 display: 'flex',
                            justifyContent: 'center',
                                alignItems: 'center',
                            position: 'relative'
                            }}>
                            <img
                                onContextMenu={(e) => e.preventDefault()}
                            src={require('./assets/bk.png')}
                            style={{
                                resizeMode: 'contain',
                                width: 200,
                                height: 120,
                                 pointerEvents: 'none',
                            }}
                            />
                            <div style={{position: 'absolute'}}>
                            
                            <p
                                style={{color: 'white', textAlign: 'center', fontSize: 17}}>
                                MERLOT
                            </p>
                            </div>
                        </div>
                         <div
                           onClick={()=>{
                            setdishs(datanebiolo)
                            setShowListProduct(true)
                           }}
                            style={{
                                 display: 'flex',
                            justifyContent: 'center',
                                alignItems: 'center',
                            position: 'relative'
                            }}>
                            <img
                                onContextMenu={(e) => e.preventDefault()}
                            src={require('./assets/bk.png')}
                            style={{
                                resizeMode: 'contain',
                                width: 200,
                                height: 120,
                                 pointerEvents: 'none',
                            }}
                            />
                            <div style={{position: 'absolute'}}>
                           
                            <p
                                style={{color: 'white', textAlign: 'center', fontSize: 17}}>
                                NEBIOLO
                            </p>
                            </div>
                        </div>
                    </div>

                    <div
                        style={{
                            display:'flex',
                            flexDirection: 'row',
                            alignSelf: 'center',
                            justifyContent: 'center'
                        }}>
                        <div
                             onClick={()=>{
                                setdishs(datapinotnoir)
                                setShowListProduct(true)
                             }}
                            style={{
                                display: 'flex',
                                position: 'relative',
                            justifyContent: 'center',
                            alignItems: 'center',
                            }}>
                            <img
                                 onContextMenu={(e) => e.preventDefault()}
                                src={require('./assets/bk.png')}
                                style={{
                                    resizeMode: 'contain',
                                    width: 200,
                                    height: 120,
                                     pointerEvents: 'none',
                            }}
                            />
                            <div style={{position: 'absolute'}}>
                               
                                <p
                                    style={{color: 'white', textAlign: 'center', fontSize: 17}}>
                                    PINOT NOIR
                                </p>
                            </div>
                        </div>

                        <div
                             onClick={()=>{
                                setdishs(datamalbec)
                                setShowListProduct(true)
                             }}
                            style={{
                                 display:'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                            }}>
                            <img
                                onContextMenu={(e) => e.preventDefault()}
                                src={require('./assets/bk.png')}
                                style={{
                                    resizeMode: 'contain',
                                    width: 200,
                                    height: 120,
                                     pointerEvents: 'none',
                                }}
                            />
                            <div style={{position: 'absolute'}}>
                            <p
                                style={{color: 'white', textAlign: 'center', fontSize: 17}}>
                                MALBEC
                            </p>
                            </div>
                        </div>
                    </div>




                    <p style={{color: '#D7BF89', textAlign: 'center', fontSize: 35, marginTop: 30}}>
                        WHITE WINES
                    </p>

                    <div
                        style={{
                            display: 'flex',
                            marginTop: 20,
                            flexDirection: 'row',
                            alignSelf: 'center',
                            justifyContent: "center"
                        }}>
                        <div
                            onClick={()=>{
                                setdishs(chenin)
                                setShowListProduct(true)
                            }}
                            style={{
                            display: 'flex',
                            justifyContent: 'center',
                                alignItems: 'center',
                            position: 'relative'
                        }}>
                            <img
                                onContextMenu={(e) => e.preventDefault()}
                                
                                src={require('./assets/bk.png')}
                                style={{
                                    objectFit: 'contain',
                                    width: 200,
                                    pointerEvents: 'none',
                                    height: 120,
                                }}
                            />
                            <div style={{position: 'absolute'}}>
                               
                                <p
                                    style={{color: 'white', textAlign: 'center', fontSize: 17}}>
                                    CHENIN <br/>BLANC
                                </p>
                            </div>
                        </div>

                        <div
                           onClick={()=>{
                            setdishs(suavignon)
                            setShowListProduct(true)
                           }}
                            style={{
                                 display: 'flex',
                            justifyContent: 'center',
                                alignItems: 'center',
                            position: 'relative'
                            }}>
                            <img
                                onContextMenu={(e) => e.preventDefault()}
                            src={require('./assets/bk.png')}
                            style={{
                                resizeMode: 'contain',
                                width: 200,
                                height: 120,
                                 pointerEvents: 'none',
                            }}
                            />
                            <div style={{position: 'absolute'}}>
                            
                            <p
                                style={{color: 'white', textAlign: 'center', fontSize: 17}}>
                                SAUVIGNON <br/>BLANC
                            </p>
                            </div>
                        </div>
                         <div
                           onClick={()=>{
                            setdishs(moscato)
                            setShowListProduct(true)
                           }}
                            style={{
                                 display: 'flex',
                            justifyContent: 'center',
                                alignItems: 'center',
                            position: 'relative'
                            }}>
                            <img
                                onContextMenu={(e) => e.preventDefault()}
                            src={require('./assets/bk.png')}
                            style={{
                                resizeMode: 'contain',
                                width: 200,
                                height: 120,
                                 pointerEvents: 'none',
                            }}
                            />
                            <div style={{position: 'absolute'}}>
                           
                            <p
                                style={{color: 'white', textAlign: 'center', fontSize: 17}}>
                                MOSCATO
                            </p>
                            </div>
                        </div>
                    </div>

                    <div
                        style={{
                            display:'flex',
                            flexDirection: 'row',
                            alignSelf: 'center',
                            justifyContent: 'center'
                        }}>
                        <div
                             onClick={()=>{
                                setdishs(chardonnay)
                                setShowListProduct(true)
                             }}
                            style={{
                                display: 'flex',
                                position: 'relative',
                            justifyContent: 'center',
                            alignItems: 'center',
                            }}>
                            <img
                                 onContextMenu={(e) => e.preventDefault()}
                                src={require('./assets/bk.png')}
                                style={{
                                    resizeMode: 'contain',
                                    width: 200,
                                    height: 120,
                                     pointerEvents: 'none',
                            }}
                            />
                            <div style={{position: 'absolute'}}>
                               
                                <p
                                    style={{color: 'white', textAlign: 'center', fontSize: 17}}>
                                   CHARDONNAY
                                </p>
                            </div>
                        </div>

                        <div
                             onClick={()=>{
                                setdishs(pinotgrigio)
                                setShowListProduct(true)
                             }}
                            style={{
                                 display:'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                            }}>
                            <img
                                onContextMenu={(e) => e.preventDefault()}
                                src={require('./assets/bk.png')}
                                style={{
                                    resizeMode: 'contain',
                                    width: 200,
                                    height: 120,
                                     pointerEvents: 'none',
                                }}
                            />
                            <div style={{position: 'absolute'}}>
                            <p
                                style={{color: 'white', textAlign: 'center', fontSize: 17}}>
                                PINOT GRIGIO
                            </p>
                            </div>
                        </div>
                    </div>

                    
                </div>
                
                {showSpecials && <SpecialsScreen setShowHappy={setShowBar} setShowListProduct={setShowSpecials} />}

                
                {showSesonalCocktail && <SeaseonalCoktailScreen goHome={setShowBar} setShowListProduct={setShowSesonalCocktail} />}
                {showSpecialitylCocktail && <SpecialityCocktail goHome={setShowBar} setShowListProduct={setShowSpecialitylCocktail}  />}
                {showPeruvianClasic && <PeruvianClasic goHome={setShowBar} setShowListProduct={setshowPeruvianClasic} />}
                {showBeer && <BeerScreen goHome={setShowBar} setShowListProduct={setshowBeer} />}
                {showspirits && <SpiritsScreen goHome={setShowBar} setShowListProduct2={setShowSpirits} />}
                {showOldiesButGoodies && <OldiesButGoodies goHome={setShowBar} setShowListProduct={setShowOldiesButGoodies} />}

                {showListProduct && <ListProducts
                    dishs={dishs}
                    goHome={setShowBar}
                    setShowListProduct={setShowListProduct}
                />}
                
            </LayoutContent>
        </div>
    );
}
export default Index;